var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":"http://localhost:8082/fps/doc.html","width":"100%","height":"900px","frameborder":"0","scrolling":"auto"}})
}
var staticRenderFns = []

export { render, staticRenderFns }